import BaseAPI from '@/apis/base/baseApi';

class DatabaseHistoryAPI extends BaseAPI {
  constructor() {
    super();
    this.apiName = 'System'; // Assuming 'System' is the correct apiName, you might need to adjust it
    this.controllerName = 'DatabaseHistory';
  }

  /**
   * Lấy lịch sử quản lý dữ liệu theo bộ lọc
   * @param {Object} filter - Bộ lọc (from_date, to_date, user_id, action_type, page_size, page_number)
   * @returns {Promise} - Promise chứa kết quả trả về từ API
   */
  getDatabaseHistory(filter) {
    const request = {
      url: this.getAPIUrl('filter'),
      data: filter,
    };
    return this.postAsync(request);
  }
}

export default new DatabaseHistoryAPI();
